const useScreenTrack = screenTrack => {
  return {
    screenTrack,
    isEnabled: !!screenTrack,
  };
};

export default useScreenTrack;
